import { useContext, createContext } from "react";

export const CoveoEngineContext = createContext(null);

export function useCoveoEngine() {
  return useContext(CoveoEngineContext);
}
